import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { AnimationOptions } from 'ngx-lottie';
import { tap } from 'rxjs';
import { Allied } from 'src/app/interfaces/allied.interface';
import { AlliedservicesService } from 'src/app/services/alliedservices.service';
import { FreeCompaniesService } from 'src/app/services/free-companies.service';
import { GroupService } from 'src/app/services/groupservice.service';
import { CSV_CHECK, PATH_LOADER } from 'src/app/shared/data/data';
import { RequestStatus } from 'src/app/shared/data/models';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-linea-base-import',
  templateUrl: './linea-base-import.component.html',
  styleUrls: ['./linea-base-import.component.scss'],
})
export class LineaBaseImportComponent implements OnInit, OnDestroy {
  private subs = new SubSink();
  public inputArchive: FormControl;
  public archivos: any = '';
  public fileIsReady: any;
  public templateFile: File;
  public idGroup: any = this.datadialog.idGroup;
  public errorFileObject: any;
  public options: AnimationOptions;
  public status: RequestStatus = 'init';
  public fileError: boolean = false;
  public textFilesErrors: string[] = CSV_CHECK;
  public errorsInRegisters: number;
  public fileName: string = '';
  public duplicatesInRegisters: number;
  public fileExtension: string;
  public isLoaded: boolean = false;
  public organizationOptions: any;
  public invalidRowsSummary: string[] = [];
  public totalRows: number = 0;
  public totalValid: number = 0;
  public totalInvalid: number = 0;
  public totalUpdates: number = 0;
  public totalInserts: number = 0;
  public generalError: string = '';

  public hideRequiredControl = new FormControl(true);
  public importForm: FormGroup = this.fb.group({
    hideRequired: this.hideRequiredControl,
    organization: ['', [Validators.required]],
    inputFile: ['', [Validators.required]],
  });

  public selectedOrganization: any;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<LineaBaseImportComponent>,
    private groupService: GroupService,
    private alliedService: AlliedservicesService,
    @Inject(MAT_DIALOG_DATA) public datadialog: { idGroup: string },
    private _snackBar: MatSnackBar,
    private trasnlateService: TranslateService,
    private freeCompaniesService: FreeCompaniesService,
  ) {
    this.options = {
      path: PATH_LOADER,
    };
    this.freeCompaniesService.listFreeAllied().subscribe((rta: any) => {
      this.organizationOptions = rta.allieds;
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {}

  public something(event: any): void {
    event.preventDefault();
    this.archivos = event.target.files[0];
    this.showFiles(this.archivos);
  }

  public eraseFile(): void {
    this.archivos = '';
  }

  public closeModal(query?: number): void {
    this.dialogRef.close(query);
  }

  public showFiles(files: any): void {
    if (files.length == undefined) {
      this.procesFile(files);
    } else {
      for (const file of files) {
        this.procesFile(file);
      }
    }
  }

  public procesFile(file: File): void {
    this.fileExtension = file.type;
    this.fileName = file.name;
    const validExtension = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];

    if (validExtension.includes(file.type)) {
      this.templateFile = file;
      this.isLoaded = true;
      this.alliedService
        .uploadImportFile(this.selectedOrganization, this.templateFile)
        .pipe(tap(() => (this.status = 'init')))
        .subscribe({
          next: ({ summary, invalidRows }: any) => {
            this.status = 'success';
            this.totalRows = summary.totalRows;
            this.totalValid = summary.totalValid;
            this.totalInvalid = summary.totalInvalid;
            this.totalUpdates = summary.totalUpdates;
            this.totalInserts = summary.totalInserts;
            if (invalidRows && invalidRows.length > 0) {
              this.invalidRowsSummary = invalidRows.map(
                (row: any) => `Error en línea "${row.row}": ${row.errors.join(', ')}`
              );
            }
          },
          error: (err) => {
            this.status = 'error';
            this.generalError = err.error.message;
          },
        });
    } else {
      this.isLoaded = false;
    }
  }

  public downloadTempate(): void {
    const fileName = `linea_base_import_template.xlsx`;
    this.alliedService.getLineaBaseFileTemplate().subscribe((resp: any) => {
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(resp);
      a.href = objectUrl;
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(objectUrl);
    });
  }

  public finish(): void {
    this.closeModal(1);
  }

  public reCharge(): void {
    this.eraseFile();
    this.status = 'init';
    this.textFilesErrors = CSV_CHECK;
  }

  private errorRegisters(total: number, errors: number): void {
    this.fileError = total == errors ? true : false;
  }
}
